import { all, call, put, select, takeLatest } from "redux-saga/effects";

import Schemas from "../models";
import actions from "../../constants/actions";
import { getMeId } from "../selectors/me";
import { createOptions } from "../../utils/helper";
import { DELETE, GET, PUT } from "../../utils/api";

export function* getMe({ payload }) {
    let options = createOptions(payload.options);

    try {
        let response = yield call(GET, {
            url: "api/me" + options,
            schema: Schemas.USER,
        });

        yield put({ type: actions.LOAD_USER_ME_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.LOAD_USER_ME_FAIL, payload: error });
    }
}

export function* updateMe({ payload }) {
    const userId = yield select(getMeId);
    try {
        let response = yield call(PUT, {
            url: "api/users/" + userId,
            data: payload.data,
            schema: Schemas.USER,
        });

        yield put({ type: actions.UPDATE_USER_ME_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.UPDATE_USER_ME_FAIL, payload: error });
    }
}

export function* deleteMe({ payload }) {
    try {
        let response = yield call(DELETE, {
            url: "api/me/",
            data: payload.data,
            schema: Schemas.USER,
        });

        yield put({ type: actions.DELETE_USER_ME_SUCCESS, payload: response });
    } catch (error) {
        yield put({ type: actions.DELETE_USER_ME_FAIL, payload: error });
    }
}

export default function* Me() {
    yield all([
        yield takeLatest(actions.LOAD_USER_ME, getMe),
        yield takeLatest(actions.UPDATE_USER_ME, updateMe),
        yield takeLatest(actions.DELETE_USER_ME, deleteMe),
    ]);
}
